import { Icon } from '../components/Icon';
import { StepLayout } from '../components/StepLayout';
import { usePortal } from '../Portal';

export function Success() {
  const { t, state, dispatch } = usePortal();
  const inReview = state.outcome !== 'refunded' && state.outcome !== 'reordered' && state.outcome !== 'credited';

  const [title, paragraph] =
    state.outcome === 'refunded'
      ? [t('success.refund.title'), t('success.refund.body')]
      : state.outcome === 'reordered'
        ? [t('success.reorder.title'), t('success.reorder.body')]
        : state.outcome === 'credited'
          ? [t('success.storeCredit.title'), t('success.storeCredit.body')]
          : [t('success.review.title'), t('success.review.body')];

  return (
    <StepLayout
      title={title}
      paragraph={paragraph}
      onNext={() => dispatch({ type: 'RESET' })}
      nextLabel={t('success.button')}
      lead={
        // A claim still in review gets a clock, not a tick: nothing has been approved yet.
        <div className={`nvd-claim-portal__success-icon${inReview ? ' nvd-claim-portal__success-icon--pending' : ''}`} aria-hidden="true">
          <Icon name={inReview ? 'clock' : 'check'} />
        </div>
      }
    />
  );
}
